import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { CpMarketplaceApiService } from '../../services/cp-marketplace-api.service';
import { Subject, Observable, of, concat ,  pipe } from 'rxjs';
import { distinctUntilChanged, debounceTime, switchMap, tap, catchError, filter } from 'rxjs/operators';

@Component({
  selector: 'app-icici-select-input',
  templateUrl: './icici-select-input.component.html',
  styleUrls: ['./icici-select-input.component.scss']
})
export class IciciSelectInputComponent implements OnInit {

  itemsListTypes = {
    SERVER_SIDE_SEARCH: 'serverSideSearch',
    STATIC_ITEMS_LIST: 'staticItemsList'
  };

  selectTypes = {
    SINGLE_SELECT: 'single',
    MULTI_SELECT: 'multiple'
  };

  @Input() dropdownListType;
  @Input() placeholder;
  @Input() notFoundText;
  @Input() customClass = '';

  // Already selected items are passed as input.
  @Input() selectedItems: Array<any> = [];
  @Input() selectedItemsIdField;
  @Output() itemSelectedEvent = new EventEmitter<Array<any>>();
  @Output() newItemAddedEvent = new EventEmitter();
  @Output() itemRemovedEvent = new EventEmitter();
  @Output() inputClearedEvent = new EventEmitter();

  selectInputControl$;
  multiselectLoading;

  // Server Side Search and autocomplete - serverSideSearch
  @Input() itemsApiEndpoint;
  selectDropdownListApi$;

  // Static list of items in select dropdown
  @Input() dropDownItemsList;

  constructor(private apiService: CpMarketplaceApiService) { }

  ngOnInit() {
    this.selectInputControl$ = new Subject<string>();
    if (this.dropdownListType === this.itemsListTypes.SERVER_SIDE_SEARCH) {
      this.selectDropdownListApi$ = concat(
        of([]), // default items
        this.selectInputControl$.pipe(
          debounceTime(200),
          distinctUntilChanged(),
          tap(() => this.multiselectLoading = true),
          switchMap(term => this.apiService[this.itemsApiEndpoint](term).pipe(
            tap(() => this.multiselectLoading = false)
          )
          )
        )
      );
    }
  }

  onSelectInputChange(selectedItems) {
    this.itemSelectedEvent.emit(selectedItems);
  }

  onItemAdded(item) {
    this.newItemAddedEvent.emit(item);
  }

  onItemRemoved(item) {
    this.itemRemovedEvent.emit(item);
  }

  onInputClear() {
    this.inputClearedEvent.emit(true);
  }
}
